import * as Sentry from "@sentry/react";

import artifactInfo from "../../artifactInfo.json";

export function initSentry(): void {
  if (window.env.SENTRY_ENVIRONMENT !== "local") {
    Sentry.init({
      dsn: window.env.SENTRY_DNS,
      release: artifactInfo.sentryRelease,
      environment: window.env.SENTRY_ENVIRONMENT,
      integrations: [new Sentry.BrowserTracing()],
      tracesSampleRate:
        window.env.SENTRY_ENVIRONMENT === "production" ? 0.25 : 1.0,
      autoSessionTracking: true,
    });
  }
}
